import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormInput from './FormInput';
import Error from './Error';
import IpaField from './IpaField';
import IpaExplanationTable from './IpaExplanationTable';
import { Message } from 'semantic-ui-react'
import debounce from 'lodash/debounce';

/*
 * Outer input form component
 */

class Form extends Component {

  componentWillMount() {
    // defer Ajax call by a number of ms
    this.handleTextChange = debounce(this.handleTextChange, 300);
  }

  /* set input field value, but defer Ajax call */
  deferredHandleTextChange = (e) => {

    this.props.storeText(e.target.value);

    // force React to persist synthentic event so debounce has access to it:
    e.persist();
    this.handleTextChange(e);
  }

  /* actual Ajax call */
  handleTextChange = (e) => {
    const value = e.target.value.replace(/\s/g, '');

    if (value !== '') {
      return this.props.fetchData(value, this.props.ipaflavour)
    }
  };

  render() {
    const { isFetching, errText, ipa } = this.props;

    return (
      <div>
        <div className="ui padded two column stackable centered grid massive search">

          <FormInput 
            saytext={this.props.saytext} 
            isFetching={isFetching} 
            onChange={this.deferredHandleTextChange}
            onResetForm={this.props.resetForm}
          />

          <IpaField ipa={ipa} />

          { errText &&
            <Error message={errText} />
          }

          { this.props.saytext && this.props.saytext.match(/[^\wáóéàèìòù]/i) && 
            <Message warning size='mini'> Multiple words or with punctuation characters don't work well! </Message>
          }
        </div>

        {ipa &&
          <IpaExplanationTable ipa={ipa} />
        }
      
        <div className="bottom_spacer">&nbsp;</div>

      </div>

    );
  }
}

Form.propTypes = {
  saytext: PropTypes.string.isRequired,
  storeText: PropTypes.func.isRequired, 
  errText: PropTypes.string,
  isFetching: PropTypes.bool.isRequired,
  resetForm: PropTypes.func.isRequired,
  fetchData: PropTypes.func.isRequired
};


export default Form;



// WEBPACK FOOTER //
// ./src/Form.js